<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/images/company/aboutus.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">About us</h1>
                    <p class="para-desc text-white-50"></p>

                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<!-- About Start -->
<section class="section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="position-relative">
                    <!--          <img src="assets/3r/image.png" class="rounded img-fluid mx-auto d-block" alt="">-->
                    <div class="col-lg-12 col-md-12 mt-4 pt-2 ">
                        <div class="position-relative">
                            <img src="assets/3r/admin/1.PNG" class="rounded img-fluid mx-auto d-block" alt="">
                            <div class="play-icon">
                                <a (click)="openWindowCustomClass(content)" href="javascript:void(0);"
                                   class="play-btn video-play-icon">
                                    <i class="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>
                                </a>
                                <ng-template #content let-modal>
                                    <div class="modal-header">
                                        <button type="button" class="close" aria-label="Close"
                                                (click)="modal.dismiss('Cross click')">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <iframe src="assets/3r/admin/WhatsApp%20Video%202021-08-19%20at%2011.51.53%20AM.mp4"
                                                height="450" width="780"
                                                frameborder="0"
                                                allowfullscreen allow="autoplay; encrypted-media"></iframe>
                                    </div>
                                </ng-template>

                            </div>
                        </div>
                    </div>
                    <!--          <div class="play-icon">-->
                    <!--            <a (click)="openWindowCustomClass(content)" href="javascript:void(0);"-->
                    <!--               class="play-btn video-play-icon">-->
                    <!--              <i class="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>-->
                    <!--            </a>-->
                    <!--            <ng-template #content let-modal>-->
                    <!--              <div class="modal-header">-->
                    <!--                <button type="button" class="close" aria-label="Close"-->
                    <!--                        (click)="modal.dismiss('Cross click')">-->
                    <!--                  <span aria-hidden="true">&times;</span>-->
                    <!--                </button>-->
                    <!--              </div>-->
                    <!--              <div class="modal-body">-->
                    <!--                <iframe src="https://player.vimeo.com/video/99025203" height="450" width="780"-->
                    <!--                        frameborder="0"-->
                    <!--                        allowfullscreen allow="autoplay; encrypted-media"></iframe>-->
                    <!--              </div>-->
                    <!--            </ng-template>-->

                    <!--          </div>-->
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="section-title ml-lg-4">
                    <h4 class="title mb-4">Our Story</h4>
                    <p class="text-muted">
                        We, 3R International, are the best overseas education consultant in the industry today and help
                        students, every step of the way, in achieving their dream international degree.
                        Through our wide range of free support services, we guide students to their dream study
                        destination- by helping them find the courses, colleges and universities that meet their
                        expectations and needs-on a global level.
                    </p>

                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<!-- About End -->

<!-- Team Start -->
<section class="section bg-light">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Our Greatest Minds</h4>
                    <!--                    <p class="text-muted para-desc mx-auto mb-0">Start working with <span-->
                    <!--                            class="text-primary font-weight-bold">Landrick</span> that can provide everything you need-->
                    <!--                        to generate-->
                    <!--                        awareness, drive traffic, connect.</p>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/emil.JPG"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr.Emil
                                Fernandopulle</a></h5>
                            <small class="designation text-muted"> Founder CEO</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/anura%20abeywickrama%20(1).png"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr.Anura
                                Abeywickrama </a>
                            </h5>
                            <small class="designation text-muted"> Director Operations </small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
<!--            <div class="col-lg-3 col-md-6 mt-4 pt-2">-->
<!--                <div class="card team text-center bg-transparent border-0">-->
<!--                    <div class="card-body p-0">-->
<!--                        <div class="position-relative">-->
<!--                            <img src="assets/3r/admin/ll.jpeg"-->
<!--                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">-->
<!--                            &lt;!&ndash;end icon&ndash;&gt;-->
<!--                        </div>-->
<!--                        <div class="content pt-3 pb-3">-->
<!--                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr.Nelson P.-->
<!--                                Kumaranayake</a>-->
<!--                            </h5>-->
<!--                            <small class="designation text-muted">Head of legal<br>-->
<!--                                LL. B. & LL.M. (SL) TEFL-->
<!--                            </small>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/yas.jpeg"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--              <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                  <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                </a></li>-->
                            <!--                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                  <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                </a></li>-->
                            <!--                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                  <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                </a></li>-->
                            <!--                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                  <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                </a></li>-->
                            <!--              </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Miss.Yashodha
                                Abewardhana </a></h5>
                            <small class="designation text-muted">Senior Executive</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/isuru.jpeg"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr.Isuru Fernando </a>
                            </h5>
                            <small class="designation text-muted">Senior Executive</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <!--  <div class="container mt-100 mt-60">-->
    <!--    <div class="row justify-content-center">-->
    <!--      <div class="col-12 text-center">-->
    <!--        <div class="section-title">-->
    <!--          <h4 class="title mb-4">See everything about your employee at one place.</h4>-->
    <!--          <p class="text-muted para-desc mx-auto">Start working with <span-->
    <!--              class="text-primary font-weight-bold">Landrick</span> that can provide everything you need to generate-->
    <!--            awareness, drive traffic, connect.</p>-->

    <!--          <div class="mt-4">-->
    <!--            <a href="javascript:void(0)" class="btn btn-primary mt-2 mr-2">Get Started Now</a>-->
    <!--            <a href="javascript:void(0)" class="btn btn-outline-primary mt-2">Free Trial</a>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;end col&ndash;&gt;-->
    <!--    </div>-->
    <!--end row-->
    <!--  </div>-->
    <!--end container-->
</section>
<!--end section-->
<!-- Team End -->


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
